import * as angular from 'angular';

import { ComponentDefinition } from '../../models';
import { IAliasService, ILoggerService } from '../../services';

class UnitMappingController implements angular.IComponentController {
    formController: angular.IFormController;
    isLoading: boolean;
    loadingMessage: string;
    proposedAlias: any;
    unsavedList: any[];

    afterImportCallback: (data: any) => void;

    static $inject = ['aliasService', 'loggerService'];

    constructor(private _aliasService: IAliasService,
        private _loggerService: ILoggerService) {
    }
    
    saveAliasesAndImport() {
        $('#aliasModal').modal('hide');
        this.formController.$setPristine();

        const savedList = this.proposedAlias.filter(a => a.save);
        this.unsavedList = this.proposedAlias.filter(a => !a.save);

        if (savedList && savedList.length > 0) {
            this._aliasService
                .updateList(savedList)
                .then(data => {
                    this._loggerService.logSuccess('Aliases successfully updated.');
                    if (this.afterImportCallback) {
                        this.afterImportCallback({ extraList: this.unsavedList });
                    }
                })
                .catch(reason => {
                    this._loggerService.logError('Failed to update aliases.');
                });
        } else {
            if (this.afterImportCallback) {
                this.afterImportCallback({ extraList: this.unsavedList });
            }
        }
    }
}

export const wtUnitMapping: ComponentDefinition = {
    componentId: 'wtUnitMapping',
    controller: UnitMappingController,
    template: require('./unitMapping.component.html'),
    controllerAs: 'vm',
    bindings: {
        proposedAlias: '=',
        afterImportCallback: '&?'
    }
};
